export const EXAMPLE_PATH = "cms-contentful";
export const CMS_NAME = "Contentful";
export const CMS_URL = "https://www.contentful.com";
export const HOME_OG_IMAGE_URL =
  "https://images.ctfassets.net/xuxjrtfm9nvk/3MYoXyWL64fVePxVUNXo5i/a3ac49d9a58440d3d35ef91b583eed06/OpenGraph.jpg";
export const SITE_TITLE = "Salazarpardo Design Portfolio";
export const SITE_DESCRIPTION =
  "Product Design, UI, UX, and Front-end development case studies.";
